import jwtDecode from 'jwt-decode';

import { captureSentryException } from '../setup/sentry';

export const decodeJwt = (token: string | string[]) => {
  try {
    return jwtDecode(token as string);
  } catch (error) {
    captureSentryException(error as Error);
    return 'invalid token';
  }
};
